import { IGame } from '../../../../api/types/game'
import React from 'react'
import { useAuth } from '../../../../context/Auth'
import { CharacterTab } from '../Character/CharacterTab'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ItemsList } from '../../../ItemsIndex/components/ItemList/ItemList'
import { IItem } from '../../../../api/types/item'
import { GmGameItemActions } from './components/GmGameItemActions/GmGameItemActions'
import { TimeControl } from './components/TimeControl/TimeControl'

interface Props {
  game: IGame
  showChatTab?: () => void
}

export const Tools: React.FC<Props> = ({ game, showChatTab, ...props }) => {
  const auth = useAuth()

  return (
    <Box
      sx={{
        overflow: 'auto',
        height: '100%',
      }}
    >
      <CharacterTab game={game} />
      {auth && auth.gm && (
        <>
          <TimeControl game={game} />
          <Box sx={{ marginLeft: '4px', marginRight: '4px' }}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Baza przedmiotów</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ItemsList
                  columns={1}
                  reverseBackground={true}
                  displayFilteredOnly={true}
                  additionalItemActions={(item: IItem) => (
                    <GmGameItemActions game={game} item={item} />
                  )}
                />
              </AccordionDetails>
            </Accordion>
            {/*<Accordion>*/}
            {/*  <AccordionSummary expandIcon={<ExpandMoreIcon />}>*/}
            {/*    <Typography>Czary</Typography>*/}
            {/*  </AccordionSummary>*/}
            {/*  <AccordionDetails>*/}
            {/*    <Typography>Puppa</Typography>*/}
            {/*  </AccordionDetails>*/}
            {/*</Accordion>*/}
          </Box>
        </>
      )}
    </Box>
  )
}
